module.exports = __webpack_public_path__ + "img/logo_3.94216a6a.png";